<template>
    <v-row align="center">
        <v-col cols="12" sm="12" md="12">
            <v-card class="elevation-4">
                
                <v-card-title>
                    <v-toolbar flat>
                        <v-btn dark color="cyan darken-4" @click="dialog = true">
                            <v-icon left>fas fa-plus-square</v-icon>Nueva asistencia
                        </v-btn>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <v-col cols="12" md="8" sm="12" class="d-flex align-center justify-end">
                        <v-autocomplete v-model="empleadoId" :items="empleados" item-text="nombreCompleto" item-value="id"
                            label="Filtrar por empleado" clearable outlined dense hide-details class="mr-2" style="max-width: 260px;"
                            @change="searchAsistencia">
                        </v-autocomplete>

                        <v-text-field v-model="search" append-icon="fas fa-search" label="Buscar asistencia por fecha o empleado"
                            outlined dense single-inline hide-details @keydown.enter="searchAsistencia"></v-text-field>

                        <v-chip class="ml-2 flex-shrink-0" style="cursor: pointer; white-space: nowrap;"
                            :color="soloSinRaya ? 'success' : 'grey lighten-3'" :outlined="!soloSinRaya" :dark="soloSinRaya"
                            @click="soloSinRaya = !soloSinRaya; searchAsistencia()">
                            <v-icon left small>{{ soloSinRaya ? 'fas fa-check-circle' : 'fas fa-circle-notch' }}</v-icon>
                            Sin raya
                        </v-chip>

                        <v-btn icon small class="ml-2" @click="searchAsistencia"><v-icon small>fas fa-sync</v-icon></v-btn>

                        <v-tooltip left color="success" >
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon small class="ml-2" color="success" v-bind="attrs" v-on="on" dark @click="handleExcelExport">
                                    <v-icon small dark>fas fa-file-export</v-icon>
                                </v-btn>
                            </template>
                            <span>Reporte asistencias</span>
                        </v-tooltip>
                        <span class="columns-btn-fix"><Columns :headers.sync="headers"></Columns></span>
                    </v-col>
                </v-card-title>

                <v-card-text>
                <v-data-table dense :headers="filteredHeaders" :items="asistencias" class="elevation-1"
                    :loading="loading" :options.sync="options"
                    :server-items-length="totalElements" :items-per-page="itemsPerPage"
                    :page.sync="page" @page-count="totalPages = $event"
                    hide-default-footer>
                    <template v-slot:[`item.rayaId`]="{ item }">
                        <v-chip small :color="item.rayaId ? 'success' : 'grey'" dark>
                            {{ item.rayaId ? `Raya #${item.rayaId} (${item.rayaFechaInicio} - ${item.rayaFechaFin})` : 'No vinculado' }}
                        </v-chip>
                    </template>

                    <template v-slot:[`item.actions`]="{ item }">
                        <v-icon small color="red" @click="deleteAsistencia(item)">fas fa-trash</v-icon>
                    </template>

                    <template v-slot:[`item.fechaAsistencia`]="{item}">
                        {{ new Date(item.fechaAsistencia).toLocaleDateString('es-ES', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }) }}
                    </template>
                </v-data-table>
                </v-card-text>
                <v-card-actions>
                    <PaginationNumber :itemsPerPage.sync="itemsPerPage" :pageCount.sync="totalPages"
                    :totalElements.sync="totalElements" :page.sync="page" :initialize.sync="initialize" />
                </v-card-actions>
            </v-card>
        </v-col>
        <ModalNuevaAsistencia :dialog.sync="dialog" :lstAsistencia.sync="initTableAsistencia" :handleModal="handleModal" v-if="dialog"/>
        <ExcelExportAsistencia :dialog.sync="dialogExcelExport" :handleModal="handleExcelExport" v-if="dialogExcelExport"/>
    </v-row>
</template>

<script>
import ModalNuevaAsistencia from './NuevaAsistencia.vue';
import AsistenciaDataService from '../../service/empleado/asistenciaDataService';
import EmpleadoDataService from '@/service/empleado/empleadoDataService';
import { pagedTableMixin } from '@/mixins/serverTableMixin';
import ExcelExportAsistencia from './ExcelExportAsistencia.vue';
import Columns from '@/components/shared/Columns.vue';
import PaginationNumber from '@/components/shared/PaginationNumber.vue';
import { extractMessage } from '@/helpers/errorHelper';

export default {
    name: 'ListaAsistencia',
    mixins: [pagedTableMixin],
    components: { ModalNuevaAsistencia, ExcelExportAsistencia, Columns, PaginationNumber },
    created() {
        this.fetchTableData();
        this.getEmpleados();
    },
    data() {
        return {
            asistencias: [],
            empleados: [],
            empleadoId: null,
            soloSinRaya: false,

            dialog: false,
            dialogExcelExport: false,

            headers: [
                { text: 'ID', align:' d-none',  sortable: false, value: 'id', visible: false, groupable: false, show: false },
                { text: 'Fecha Asistencia', value: 'fechaAsistencia', align: 'start', sortable: false, groupable: false, show: true },
                { text: 'Empleado',  value: 'empleado.nombreCompleto', align: 'start', sortable: false, groupable: false, show: true },
                { text: 'Sucursal', value: 'empleado.sucursal.nombre', sortable: false, groupable: false, show: true },
                { text: 'Raya', value: 'rayaId', align: 'center', sortable: false, groupable: false, show: true },
                { text: 'Acciones', value: 'actions', align: 'center', sortable: false, groupable: false, show: true },
            ]
        }
    },
    methods: {
        async getEmpleados() {
            this.empleados = await EmpleadoDataService.all().then( resp => resp.data ) || [];
        },
        searchAsistencia(){
            this.doSearch();
        },
        fetchTable(params){
            return AsistenciaDataService.table( params );
        },
        applyRows({ rows, total, totalPages }){
            this.asistencias = rows;
            this.totalElements = total;
            this.totalPages = totalPages;
        },
        // Callback que reciben los diálogos de alta y edición.
        initTableAsistencia(){
            this.reload();
        },
        deleteAsistencia(item){
            this.$swal.fire({
                title: '¿Eliminar esta asistencia?',
                text: `${item.empleado.nombreCompleto} - ${new Date(item.fechaAsistencia).toLocaleDateString('es-ES')}`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si, eliminar',
                cancelButtonText: 'No'
            }).then( result => {
                if (result.isConfirmed) {
                    AsistenciaDataService.delete(item.id).then(() => {
                        this.$swal.fire({ icon: 'success', title: 'Asistencia eliminada', showConfirmButton: false, timer: 1500 });
                        this.initTableAsistencia(this.options);
                    }).catch(err => {
                        this.$swal.fire({ icon: 'error', title: 'Error al eliminar', text: extractMessage(err), showConfirmButton: false, timer: 2500 });
                    });
                }
            });
        },
        handleModal(){ this.dialog = !this.dialog; },
        handleExcelExport(){ this.dialogExcelExport = !this.dialogExcelExport },
    },

    computed: {

        // Filtros dinámicos: el mixin los manda al backend y
        // resetea la página a 1 cuando cambian.
        tableFilters() {
            return {
                empleadoId: this.empleadoId,
                soloSinRaya: this.soloSinRaya
            };
        },
        filteredHeaders() { return this.headers.filter((item) => item.show); }
    }
}
</script>

<style scoped>
.columns-btn-fix ::v-deep .v-btn {
    margin-top: 0 !important;
}
</style>